import Vue from 'vue'
import rpc from '../rpc.js'

function initialState() {
    return {
        searchGroups: [
            {
                id: 0,
                filters: [
                    {
                        id: 0,
                        groupId: 0,
                        field: "taken",
                        term: "",
                        isDate: true
                    }
                ],
                conjunctive: true
            }
        ],
        conjunctive: true,
        groupCount: 0,
        filterCount: 0,
        page: 0,
        pages: 0,
        searchResult: []
    }
}

export default {
    namespaced: true,
    state: initialState,
    mutations: {
        reset(state) {
            const s = initialState()
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
        newSearch(state) {
            state.groupCount = 0;
            state.filterCount = 0;
            state.searchGroups = [
                {
                    id: 0,
                    filters: [
                        {
                            id: 0,
                            groupId: 0,
                            field: "taken",
                            term: "",
                            isDate: true
                        }
                    ],
                    conjunctive: true
                }
            ];
            state.conjunctive = true;
        },
        setSearchGroups(state, searchGroups) {
            state.searchGroups = searchGroups;
        },
        setConjunctive(state, conjunctive) {
            state.conjunctive = conjunctive;
        },
        gotResults(state, results) {
            state.searchResult = results.images;
            state.pages = results.pages;
        },
        newGroup(state) {
            state.groupCount++;
            state.searchGroups.push({
                id: state.groupCount, 
                filters: [], 
                conjunctive: true
            });
            this.commit("search/newFilter", state.groupCount);
        },
        deleteGroup(state, group) {
            for(let i=0;i<state.searchGroups.length; i++) {
                if(state.searchGroups[i].id == group.id) {
                    Vue.delete(state.searchGroups, i);
                    break;
                }
            }
        },
        newFilter(state, groupId) {
            let group = null;
            for(let stateGroup of state.searchGroups) {
                if(stateGroup.id == groupId) {
                    group = stateGroup;
                    break;
                }
            }
            if(group != null) {
                state.filterCount++;
                group.filters.push({
                    id: state.filterCount,
                    groupId: groupId,
                    field: "taken",
                    isDate: true
                })
            }
        },
        deleteFilter(state, filter) {
            let group = null;
            for(let stateGroup of state.searchGroups) {
                if(stateGroup.id == filter.groupId) {
                    group = stateGroup;
                    break;
                }
            }
            if(group != null) {
                for(let i=0; i<group.filters.length; i++) {
                    if(group.filters[i].id == filter.id) {
                        Vue.delete(group.filters, i);
                        break;
                    }
                }
            }
        },
        fieldChanged(state, {groupId, filterId, field}) {
            let group = null;
            for(let stateGroup of state.searchGroups) {
                if(stateGroup.id == groupId) {
                    group = stateGroup;
                    break;
                }
            }
            if(group != null) {
                for(let i=0; i<group.filters.length; i++) {
                    if(group.filters[i].id == filterId) {
                        group.filters[i].field = field;
                        if(field == "taken") {
                            Vue.set(group.filters[i], "isDate", true);
                        } else {
                            Vue.set(group.filters[i], "isDate", false);
                        }
                        break;
                    }
                }
            }
        },
        termChanged(state, {groupId, filterId, term}) {
            let filter = findFilter(state, groupId, filterId);
            if(filter != null)  {
                filter.term = term;
            }
        },
        startChanged(state, {groupId, filterId, start}) {
            let filter = findFilter(state, groupId, filterId);
            if(filter != null)  {
                filter.start = start;
            }
        },
        endChanged(state, {groupId, filterId, end}) {
            let filter = findFilter(state, groupId, filterId);
            if(filter != null)  {
                filter.end = end;
            }
        },
        groupConjunctive(state, {groupId, conjunctive}) {
            for(let stateGroup of state.searchGroups) {
                if(stateGroup.id == groupId) {
                    stateGroup.conjunctive = conjunctive;
                    break;
                }
            }
        },
        gotoPage(state, page) {
            state.page = page;
        }
    },
    actions: {
        async advancedSearch({ commit, state, dispatch }) {
            let mySearchGroups = convertSearchGroups(state.searchGroups);
            let searchResult = await rpc.request("ImageService.AdvancedSearch", {searchGroups: mySearchGroups, conjunctive: state.conjunctive, page: state.page})
            console.log(searchResult);
            commit("gotResults", searchResult);
        },
        gotoPage({commit, state, dispatch}, page) {
            if(page>=0 && page < state.pages) {
                commit("gotoPage", page);
                dispatch("advancedSearch");
            }
        }
    }
}

function convertSearchGroups(searchGroups) {
    let newGroups = [];
    for(let oldGroup of searchGroups) {
        let newGroup = {
            conjunctive: oldGroup.conjunctive,
            filters: [],
            timeRanges: []
        }
        for(let filter of oldGroup.filters) {
            if(filter.isDate) {
                newGroup.timeRanges.push(filter);
            } else {
                newGroup.filters.push(filter);
            }
        }
        newGroups.push(newGroup);
    }
    return newGroups;
}

function findGroup(state, groupId) {
    let group = null;
    for(let stateGroup of state.searchGroups) {
        if(stateGroup.id == groupId) {
            group = stateGroup;
            break;
        }
    }
    return group;
}

function findFilter(state, groupId, filterId) {
    let group = findGroup(state, groupId);
    if(group != null) {
        for(let i=0; i<group.filters.length; i++) {
            if(group.filters[i].id == filterId) {
                return group.filters[i];
            }
        }
    }
    return null;
}